"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getOverrideSetting = exports.setOverrideSettings = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var overrideSettings = {};

var setOverrideSettings = function setOverrideSettings(overrideSettingsInput) {
  overrideSettings = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, overrideSettings), overrideSettingsInput);
};

exports.setOverrideSettings = setOverrideSettings;

var getOverrideSetting = function getOverrideSetting(key) {
  return overrideSettings[key];
};

exports.getOverrideSetting = getOverrideSetting;